export default __webpack_public_path__ + "static/media/longchamp8.60c5912d.jpg";